<template>
    <span class="icon-wrap shadow-none flex align-items-center justify-content-center" v-bind="$attrs">
        <IconSvg :name="iconName" :width="width" :height="height || width" :fill="fill" />
    </span>
</template>

<script>
import IconSvg from "./Icon-Svg.vue";

export default {
    name: "IconWrap",

    components: {
        IconSvg,
    },

    props: {
        iconName: {
            type: String,
            required: true,
        },

        width: {
            type: String,
            default: "16px",
        },

        height: {
            type: String,
            default: "16px",
        },

        fill: {
            type: String,
            default: "#667085",
        }, 

        styles: {
            type: [String, Object],
            default: undefined,
        },
    },
};
</script>

<style lang="scss" scoped>
    .icon-wrap {
        border-radius: 5px;
        border: 1px solid #e6e5e5;
        padding: 3px 5px;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px 0px;
        width: 30px;
        height: 30px;
    }
</style>